// extracted by mini-css-extract-plugin
export default {"root":"AttachBotIcon-module__root","compact":"AttachBotIcon-module__compact","image":"AttachBotIcon-module__image"};